import React, { memo } from 'react'
import { Container, Grid, Paper } from '@mui/material'
import Image from '@v4/components/common/Image'
import PropTypes from 'prop-types'
import PageMetaData from '@v4/utils/data/PageMetaData'
import CommonContent from '../../../../components/Content'
import { useContent } from './Content.hooks'

const Content = props => {
	const [
		{
			classes,
			cx,
			withImage,
			mobileAlignment,
			mobileButtonWidth,
			image,

			text,
			buttonText,
			buttonTextEditable,
			buttonLink,
			buttonAction,
			extraShortcuts,
			textEditable,
			buttonTextConfig,
			textConfig,
			buttonTextKey,
			textKey,
		},
		{ handleImageClick, handleTextClick, handleButtonClick, handleTextChange, handleButtonTextChange, handleClick },
	] = useContent(props)

	return (
		// eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
		<div className={cx(classes.root)} onClick={handleClick}>
			<Container className={cx(classes.container)}>
				<Grid container justifyContent="center">
					<Grid
						size={{
							md: 10,
						}}
					>
						<Paper elevation={0} className={cx(classes.paper)}>
							{withImage && (
								<Image onClick={handleImageClick} className={cx(classes.imageBox)} metaData={image} />
							)}
							<CommonContent
								mobileAlignment={mobileAlignment}
								mobileButtonWidth={mobileButtonWidth}
								text={text}
								textConfig={textConfig}
								buttonText={buttonText}
								buttonTextConfig={buttonTextConfig}
								buttonLink={buttonLink}
								buttonAction={buttonAction}
								classes={{
									content: cx(classes.content),
									buttonWrap: cx(classes.buttonWrap),
								}}
								isPaper
								className={cx(classes.cardContainer)}
								onTextClick={handleTextClick}
								onClick={handleClick}
								onButtonClick={handleButtonClick}
								extraShortcuts={extraShortcuts}
								textEditable={textEditable}
								onTextChange={handleTextChange}
								onButtonTextChange={handleButtonTextChange}
								buttonTextEditable={buttonTextEditable}
								textKey={textKey}
								buttonTextKey={buttonTextKey}
							/>
						</Paper>
					</Grid>
				</Grid>
			</Container>
		</div>
	)
}

Content.propTypes = {
	buttonAction: PropTypes.string,
	buttonLink: PropTypes.string,
	buttonText: PropTypes.string,
	buttonTextConfig: PropTypes.object,
	buttonTextEditable: PropTypes.bool,
	textConfig: PropTypes.object,
	classes: PropTypes.shape({
		root: PropTypes.string,
		container: PropTypes.string,
		paper: PropTypes.string,
		imageBox: PropTypes.string,
		cardContainer: PropTypes.string,
		content: PropTypes.string,
		buttonWrap: PropTypes.string,
	}),
	image: PropTypes.instanceOf(PageMetaData),
	onButtonClick: PropTypes.func,
	onImageClick: PropTypes.func,
	onTextClick: PropTypes.func,
	text: PropTypes.string,
	withImage: PropTypes.bool,
	extraShortcuts: PropTypes.objectOf(PropTypes.string),
	textEditable: PropTypes.bool,
	onTextChange: PropTypes.func,
	onButtonTextChange: PropTypes.func,
	textKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	buttonTextKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	mobileAlignment: PropTypes.string,
	mobileButtonWidth: PropTypes.string,
	onClick: PropTypes.func,
}

export default memo(Content)
